import { useParams, Redirect, useQuery } from '@truepill/tpos-react-router'
import { GET_ORDER_BY_CORE_ORDER_TOKEN } from 'gql'
import { goToViewPharmacyOrder } from 'routes'
import type { OrderQueryResult } from 'types'
import { OrderNotFound } from './OrderNotFound'

export const LoadFromCoreOrderToken = (): JSX.Element => {
  const routeParams = useParams<{ coreOrderToken: string }>()

  const { data } = useQuery<OrderQueryResult>(GET_ORDER_BY_CORE_ORDER_TOKEN, {
    variables: { coreOrderToken: routeParams.coreOrderToken },
  })

  if (data?.order?._id) {
    const orderUrl = goToViewPharmacyOrder({ orderId: data.order._id })
    return <Redirect to={orderUrl} />
  }

  if (data?.order === null) {
    return (
      <OrderNotFound>
        Could not find order for Order Token: <strong>{routeParams.coreOrderToken}</strong>
      </OrderNotFound>
    )
  }

  return <></>
}
